export const SCHEDULING_MODES = {
  DO_NOT_HELP: 'DO_NOT_HELP',
  WEAVE_DIRECT_SCHEDULING: 'WEAVE_DIRECT_SCHEDULING',
  WEAVE_REQUEST_SCHEDULING: 'WEAVE_REQUEST_SCHEDULING',
} as const;

export type SchedulingMode = (typeof SCHEDULING_MODES)[keyof typeof SCHEDULING_MODES];

export interface LocationSchedulingSetting {
  locationId: string;
  mode: SchedulingMode;
}
